@if (activeFilters && activeFilters.length > 0) {
  <mat-chip-listbox class="active-filters-container" aria-label="Filtros activos">
    @for (filter of activeFilters; track filter.id) {
      <mat-chip-row
        class="filter-chip"
        (removed)="removeFilter(filter.id)"
        [removable]="true">
        <span class="chip-category">{{ filter.categoryDisplay }}:</span>
        <span class="chip-value">{{ filter.valueDisplay }}</span>
        <button matChipRemove [attr.aria-label]="'Quitar filtro ' + filter.valueDisplay">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip-row>
    }
  </mat-chip-listbox>
}
